import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import {
  IConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
} from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { LoginComponent } from '@modules/auth/pages/login/login.component';
import { RecuperarSenhaComponent } from '@modules/auth/pages/recuperar-senha/recuperar-senha.component';
import { AlterarSenhaComponent } from '@modules/auth/pages/alterar-senha/alterar-senha.component';
import { LogoutComponent } from '@modules/auth/pages/logout/logout.component';

import {
  LoginController,
  RecuperarSenhaController,
  AlterarSenhaController,
  LogoutController,
} from '@modules/auth/controllers';
import { ClientChangeController } from './controllers/client-change.controller';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    LoginComponent,
    RecuperarSenhaComponent,
    AlterarSenhaComponent,
    LogoutComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [
    provideNgxMask(maskConfig),
    LoginController,
    RecuperarSenhaController,
    AlterarSenhaController,
    LogoutController,
    ClientChangeController
  ],
})
export class AuthModule {}
